module.exports = ".kan-note-dialog-container {\n  font-size: 13px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/dialogs/note-dialog/component.scss
// module id = ./src/modules/admin/dialogs/note-dialog/component.scss
// module chunks = main